import React from "react";
import LabelField from "component/labelField/LabelField";
import t from "module/translations";
import { getCertificationStateTranslation } from "module/certification/helper/getCertificationStateTranslation";
import { CertificationState } from "module/certification/types";

interface Props {
  state: CertificationState;
}

const CertificationStateLabelField: React.FC<Props> = ({ state }) => {
  return (
    <LabelField
      {...{
        caption: t.competencyManagement.certification.stateText,
        label: getCertificationStateTranslation(state),
      }}
    />
  );
};

export default React.memo(CertificationStateLabelField);
